/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  X,
  LayoutDashboard,
  Check,
  RefreshCw,
  Lock,
  Info,
  Database,
  BarChart,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationVendex({ close }) {
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.vendex.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.vendex.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = "9999999999";
      },
    });
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top { z-index: 9999999999 !important; }
      .swal-backdrop-on-top { background: rgba(0,0,0,0.7) !important; }
      .swal-popup-on-top { position: relative; box-shadow: 0 0 20px rgba(0,0,0,0.2); }
      body.swal2-shown { overflow: hidden; }
      body.swal2-shown > [aria-hidden="true"] { filter: blur(3px); }
    `;
    document.head.appendChild(style);

    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) swalContainer.style.zIndex = "9999999999";
    };
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleToggle = () => {
    setData({ ...data, VendexActive: !data.VendexActive });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1) service activé ?
    if (!data.VendexActive) {
      await Swal.fire({
        icon: "warning",
        title: t("servicePageActivation.vendex.locked.notActive.title"),
        text: t("servicePageActivation.vendex.locked.notActive.text"),
      });
      return;
    }

    // 2) clé / token obligatoire
    if (!data.vendexToken) {
      await Swal.fire({
        icon: "warning",
        title: t("servicePageActivation.vendex.locked.missingApi.title"),
        text: t("servicePageActivation.vendex.locked.missingApi.text"),
      });
      return;
    }

    try {
      setLoading(true);

      apicache(account, products);
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);

      await Swal.fire({
        icon: "success",
        title: t("servicePageActivation.vendex.success.title"),
        text: t("servicePageActivation.vendex.success.text"),
      });
      close();
    } catch (error) {
      setLoading(false);

      await Swal.fire({
        icon: "error",
        title: t("servicePageActivation.vendex.errorSaving.title"),
        text: t("servicePageActivation.vendex.errorSaving.text"),
      });

      console.error("Error saving Vendex settings:", error);
    }
  };

  const handleDisable = async (e) => {
    e.preventDefault();

    if (!data.vendexToken && !data.VendexActive) {
      await Swal.fire({
        icon: "info",
        title: t("servicePageActivation.vendex.alreadyDisabled.title"),
        text: t("servicePageActivation.vendex.alreadyDisabled.text"),
      });
      return;
    }

    try {
      setLoading(true);

      const updatedData = {
        ...data,
        vendexToken: "",
        VendexActive: false,
      };

      await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
      dispatch(applyStoreDraft(store, updatedData));

      setLoading(false);

      await Swal.fire({
        icon: "success",
        title: t("servicePageActivation.vendex.disabled.title"),
        text: t("servicePageActivation.vendex.disabled.text"),
      });

      setData(updatedData);
      close();
    } catch (error) {
      setLoading(false);

      await Swal.fire({
        icon: "error",
        title: t("servicePageActivation.vendex.errorDisabling.title"),
        text: t("servicePageActivation.vendex.errorDisabling.text"),
      });

      console.error("Error disabling Vendex:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.vendex.paidFeature.title"),
      t("servicePageActivation.vendex.paidFeature.text"),
      true,
      t("servicePageActivation.vendex.paidFeature.confirmButton")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  const vendexBenefits = [
    {
      title: t("servicePageActivation.vendex.benefits.0.title"),
      description: t("servicePageActivation.vendex.benefits.0.description"),
      icon: <Database className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t("servicePageActivation.vendex.benefits.1.title"),
      description: t("servicePageActivation.vendex.benefits.1.description"),
      icon: <BarChart className="text-blue-500" size={20} />,
    },
    {
      title: t("servicePageActivation.vendex.benefits.2.title"),
      description: t("servicePageActivation.vendex.benefits.2.description"),
      icon: <LayoutDashboard className="text-green-500" size={20} />,
    },
  ];

  // Lock screen (même logique que ton code)
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] text-center">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 dark:!bg-yellow-900/20 rounded-full flex items-center justify-center">
                <Lock size={36} className="text-yellow-500 dark:text-yellow-400" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] dark:text-[#b47ed6] mb-3">
              {t("servicePageActivation.vendex.locked.title")}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto">
              {t("servicePageActivation.vendex.locked.description")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.vendex.locked.button")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] dark:!text-[#b47ed6] mb-2 flex items-center">
            <LayoutDashboard className="ml-2" size={20} />
            {t("servicePageActivation.vendex.title")}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {t("servicePageActivation.vendex.description")}
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 dark:!bg-blue-900/20 rounded-lg border border-blue-200 dark:!border-blue-700 p-4 flex mb-6">
            <Info
              size={20}
              className="text-blue-500 dark:text-blue-400 ml-2 flex-shrink-0 mt-1"
            />
            <div>
              <p className="font-medium text-blue-800 dark:text-blue-300 mb-1">
                {t("servicePageActivation.vendex.infoBoxTitle")}
              </p>
              <p className="text-blue-700 dark:text-blue-400 text-sm">
                {t("servicePageActivation.vendex.infoBoxDescription")}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <label className="block text-sm font-medium text-[#9e68ba] dark:text-[#b47ed6] mb-4">
              {t("servicePageActivation.vendex.toggleLabel")}
            </label>

            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                data.VendexActive
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#2a1f3a] dark:!border-[#3c3a3d]"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181919] dark:!border-[#3c3a3d] dark:hover:bg-[#2c2a2d]"
              }`}
              onClick={handleToggle}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={!!data.VendexActive}
                  onChange={() => {}}
                  className="hidden"
                  id="toggle-vendex"
                />
                <label
                  htmlFor="toggle-vendex"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${
                    data.VendexActive ? "bg-purple-400" : ""
                  }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${
                      data.VendexActive ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                    }`}
                  />
                </label>
              </div>

              <div>
                <p className="font-medium dark:text-gray-200">
                  {data.VendexActive
                    ? t("servicePageActivation.vendex.toggleActive")
                    : t("servicePageActivation.vendex.toggleInactive")}
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {data.VendexActive
                    ? t("servicePageActivation.vendex.toggleSubActive")
                    : t("servicePageActivation.vendex.toggleSubInactive")}
                </p>
              </div>
            </div>
          </div>

          {/* API Configuration */}
          {data.VendexActive && (
            <div className="space-y-4">
              <h4 className="font-medium text-[#9e68ba] dark:text-[#b47ed6]">
                {t("servicePageActivation.vendex.apiSectionTitle")}
              </h4>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  {t("servicePageActivation.vendex.apiLabel")}
                </label>

                <input
                  type="text"
                  className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#141414] dark:!border-[#3c3a3d] dark:text-gray-200 transition-colors"
                  placeholder={t("servicePageActivation.vendex.apiPlaceholder")}
                  value={data.vendexToken || ""}
                  onChange={(e) => setData({ ...data, vendexToken: e.target.value })}
                />

                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {t("servicePageActivation.vendex.apiNote")}
                </p>
              </div>
            </div>
          )}

          {/* Feature Highlights */}
          {data.VendexActive && (
            <div className="space-y-4 mt-6">
              <h4 className="font-medium text-[#9e68ba] dark:text-[#b47ed6]">
                {t("servicePageActivation.vendex.featuresTitle")}
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {vendexBenefits.map((benefit, index) => (
                  <div
                    key={index}
                    className="bg-white dark:!bg-[#181919] rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] shadow-sm"
                  >
                    <div className="flex items-center mb-2">
                      {benefit.icon}
                      <h5 className="font-medium text-gray-800 dark:text-gray-200 mr-2 text-sm">
                        {benefit.title}
                      </h5>
                    </div>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      {benefit.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tips Section */}
          <div className="bg-yellow-50 dark:!bg-[#3e3116] p-4 rounded-lg border border-yellow-100 dark:!border-[#5a4b1e]">
            <h4 className="font-medium text-lg text-yellow-800 dark:text-yellow-300 mb-2 flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.vendex.tipsTitle")}
            </h4>
            <ul className="text-sm text-gray-700 dark:text-gray-400 space-y-2 mr-5 list-disc">
              <li>{t("servicePageActivation.vendex.tip1")}</li>
              <li>{t("servicePageActivation.vendex.tip2")}</li>
              <li>{t("servicePageActivation.vendex.tip3")}</li>
            </ul>
          </div>

          {/* Submit + Cancel Buttons */}
          <div className="d-flex justify-content-between mt-4">
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("servicePageActivation.vendex.saving")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("servicePageActivation.vendex.save")}
                </>
              )}
            </button>

            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center"
              onClick={handleDisable}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("servicePageActivation.vendex.cancel")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}